export const PROJECT_CODE = 'CS'

export const PROJECT_CODE_V2 = 'CS_V2'

export const MANAGER = 'MANAGER'

export const ROP = 'HEAD_SALES'

export const ROP_CS = 'HEAD_SALES_CS'

export const SUPER_HEAD_SALES = 'SUPER_HEAD_SALES'

export const MANAGER_AUTO_DAMU = 'MANAGER_AUTO_DAMU'

export const SPP = 'SPP'

export const ACCESS_TO_PROJECT = [
  MANAGER,
  ROP,
  ROP_CS,
  SUPER_HEAD_SALES,
  SPP,
  MANAGER_AUTO_DAMU
]

export const ROP_ROLES = [ROP, ROP_CS, SUPER_HEAD_SALES]
